import React from "react";

import { Skeleton } from "shared/ui";

import { Grid } from "features/MenuEditor/components/MenuItemsGrid/styles";

import { Rows, TileBody, TileCard } from "./styles";

const SIDEBAR_ROWS = 5;
const TILES = 4;

export const CategoryListSkeleton = () => (
    <Rows>
        {Array.from({ length: SIDEBAR_ROWS }).map((_item, index) => (
            <Skeleton key={index} height="44px" />
        ))}
    </Rows>
);

export const MenuItemsGridSkeleton = () => (
    <Grid>
        {Array.from({ length: TILES }).map((_item, index) => (
            <TileCard key={index}>
                <Skeleton height="170px" radius="8px 8px 0 0" />
                <TileBody>
                    <Skeleton height="18px" width="70%" />
                    <Skeleton height="14px" width="90%" />
                    <Skeleton height="14px" width="40%" />
                </TileBody>
            </TileCard>
        ))}
    </Grid>
);
